module.exports = (__webpack_require__(7))(12);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/webpack/buildin/global.js from dll-reference vendor
// module id = 192
// module chunks = 1